module.exports = __webpack_public_path__ + "static/img/img1.41e9d86.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/img1.png
// module id = sW+G
// module chunks = 1